import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type StorageLimitedResourcesInfoFragment = { __typename?: 'AccountSubscription', limitedResources?: { __typename?: 'LimitedResources', storageBytes?: { __typename?: 'LimitedResource', limit53?: number | null, used53?: number | null } | null, mountedStorageBytes?: { __typename?: 'LimitedResource', limit53?: number | null, used53?: number | null } | null, archivedStorageBytes?: { __typename?: 'LimitedResource', limit53?: number | null, used53?: number | null } | null } | null };

export type SubscriptionStorageSubscriptionVariables = Types.Exact<{
  scope: Types.AccountSubscriptionSubscriptionScopeInput;
}>;


export type SubscriptionStorageSubscription = { __typename?: 'Subscription', accountSubscription?: { __typename?: 'UpdateAccountSubscriptionPayload', accountSubscription?: { __typename?: 'AccountSubscription', id: string, limitedResources?: { __typename?: 'LimitedResources', storageBytes?: { __typename?: 'LimitedResource', limit53?: number | null, used53?: number | null } | null, mountedStorageBytes?: { __typename?: 'LimitedResource', limit53?: number | null, used53?: number | null } | null, archivedStorageBytes?: { __typename?: 'LimitedResource', limit53?: number | null, used53?: number | null } | null } | null } | null } | null };

export const StorageLimitedResourcesInfo = /*#__PURE__*/ gql`
    fragment StorageLimitedResourcesInfo on AccountSubscription {
  limitedResources {
    storageBytes {
      limit53
      used53
    }
    mountedStorageBytes {
      limit53
      used53
    }
    archivedStorageBytes {
      limit53
      used53
    }
  }
}
    ` as unknown as DocumentNode<StorageLimitedResourcesInfoFragment, unknown>;
export const SubscriptionStorage = /*#__PURE__*/ gql`
    subscription SubscriptionStorage($scope: AccountSubscriptionSubscriptionScopeInput!) {
  accountSubscription(scope: $scope) {
    ... on UpdateAccountSubscriptionPayload {
      accountSubscription {
        id
        ...StorageLimitedResourcesInfo
      }
    }
  }
}
    ${StorageLimitedResourcesInfo}` as unknown as DocumentNode<SubscriptionStorageSubscription, SubscriptionStorageSubscriptionVariables>;

        

        
export const useStorageLimitedResourcesInfoFragment = (
  input: string | Omit<UseFragmentOptions<StorageLimitedResourcesInfoFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AccountSubscription' } };
    return input;
  })();

  return useFragment<StorageLimitedResourcesInfoFragment>({
    fragment: StorageLimitedResourcesInfo,
    fragmentName: 'StorageLimitedResourcesInfo',
    ...options,
  });
};
  
        
          

          export const useSubscriptionStorageSubscription = (options?:SubscriptionHookOptions<SubscriptionStorageSubscription, SubscriptionStorageSubscriptionVariables>) => useSubscription(SubscriptionStorage, options);

          

          export type SubscriptionStorageSubscriptionOptions = SubscriptionHookOptions<SubscriptionStorageSubscription, SubscriptionStorageSubscriptionVariables>;

          

          export type SubscriptionStorageSubscriptionResult = ReturnType<typeof useSubscriptionStorageSubscription>;

          
